// src/components/Header/Header.tsx
import React from 'react';
import './Header.css';

interface HeaderProps {
  mainTitle: string[];
  subtitle: string;
}

const Header: React.FC<HeaderProps> = ({ mainTitle, subtitle }) => {
  return (
    <header className="header">
      <div className="header-pattern"></div>
      <div className="header-ornament">✦</div>
      <div className="header-content">
        {mainTitle.map((title, index) => (
          <h1 key={index} className="main-title">
            {title}
          </h1>
        ))}
        <p className="subtitle">{subtitle}</p>
      </div>
    </header>
  );
};

export default Header;